import { render, staticRenderFns } from "./ObjectStoreSelectButton.vue?vue&type=template&id=9197e5a8"
import script from "./ObjectStoreSelectButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObjectStoreSelectButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports